import { NgModule } from '@angular/core';

import { sentryClientMonitoring } from '../sentry/sentry-client-monitoring';
import { MonitoringModule } from './monitoring.interface';
import { MONITORING } from './monitoring.token';
import { MonitoringAdapter } from './monitoring-adapter';
import { MonitoringLogger } from './monitoring-logger';
import { DatadogMonitoring } from './datadog-client-monitoring';
import { clientConsoleMonitoring } from './console-client-monitoring';
import { handleChunkLoadError } from './chunk-load';

/** The client monitoring adapter, composing the console, Sentry and Datadog backends. */
export const clientMonitoring: MonitoringModule = new MonitoringAdapter(
  [clientConsoleMonitoring, sentryClientMonitoring, new DatadogMonitoring()],
  handleChunkLoadError
);

export const initClientMonitoring = (): void => clientMonitoring.init();

@NgModule({
  providers: [{ provide: MONITORING, useValue: clientMonitoring }, MonitoringLogger],
})
export class MonitoringAdapterModule {}
